export const chassisNumberFinder = (
  stopActivity: any,
  activityType: string
) => {
  const STAC =
    stopActivity &&
    Object.getOwnPropertyNames(stopActivity).length !== 0 &&
    stopActivity.find(
      (item: any) =>
        item.execActivity === activityType ||
        item.equipmentFlow === activityType
    );
  return (STAC && STAC.chassisNumber) || null;
};
